/* eslint-disable */
import acvApiConstantKeys from '@/constants/acvApiConstantKeys';
import isEmpty from 'lodash.isempty';
import get from 'lodash.get';
import ConstantsClient from '@/api/ConstantsClient';
import AuctionHouseClient from '@/api/AuctionHouseClient';

const acvApiConstants = {
  state: {
    constants: {},
    keys: {
      // DEPRECATED - import keys directly and update existing usage - ETC
      ...acvApiConstantKeys,
    },
  },
  mutations: {
    setConstant(state, constant) {
      if (!state.constants) {
        state.constants = {};
      }
      state.constants[constant.key] = {
        value: constant.value,
        expires:  Date.now() + (Number.parseInt(import.meta.env.VITE_CONSTANTS_TTL, 10) || (1000*60*60)),
      };
    },
  },
  actions: {
    async getAcvApiConstant({ commit, state, rootGetters }, { key }) {
      if (!isEmpty(state.constants)
        && get(state.constants[key], 'expires', 0) > Date.now()) {
        return Promise.resolve(state.constants[key].value);
      }
      try {
        if (key === acvApiConstantKeys.proxyBidTypes) {
          const auctionHouseClient = new AuctionHouseClient(rootGetters.currentUser);
          const data = await auctionHouseClient.getProxyBidTypes();
          commit('setConstant', { value: data, key });
          return get(state.constants[key], 'value');
        }
        const constantsClient = new ConstantsClient(rootGetters.currentUser);
        const response = await constantsClient.get(key, true);
        commit('setConstant', { value: response.data.data, key });
        return get(state.constants[key], 'value');
      } catch (error) {
        throw new Error(error.message);
      }
    },
  },
};

export default acvApiConstants;
